import { defineComponent as _defineComponent } from 'vue'
import { useAppStore } from '@/helpers/composables/useStores';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CanaryMarker',
  setup(__props) {

const { xServeTrack } = useAppStore();

const canaryMarker = computed(() => {
	if (xServeTrack.value == null || xServeTrack.value === 'prod' || xServeTrack.value === 'canary-public') return null;

	return xServeTrack.value.replaceAll('-', ' ');
});

return { __sfc: true,xServeTrack, canaryMarker }
}

})